/* tslint:disable */
export var icon = "\n<svg width=\"8\" height=\"8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"4\" cy=\"4\" r=\"4\" fill=\"#EE5951\"/></svg>\n";
//# sourceMappingURL=red-dot.svg.js.map